import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { general } from 'src/app/models/general';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-solicitud-relampago',
  templateUrl: './solicitud-relampago.component.html',
  styleUrls: ['./solicitud-relampago.component.css']
})
export class SolicitudRelampagoComponent implements OnInit {

  public modelGeneral

  constructor(private dialogRef: MatDialogRef<SolicitudRelampagoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private user: UserService) {
      this.modelGeneral = new general();
      Object.keys(this.data).forEach(key => {
        this.modelGeneral[key] = this.data[key]
      })
     }

  ngOnInit(): void {
  }

  cerrar() {
    this.dialogRef.close({ data: false });
  }

  guardar(){
    this.dialogRef.close({ data: this.modelGeneral });
  }
}
